// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ThemeManager } from '@front/controls/misc/ThemeManager';
import { SolidBrush } from '@shared/commons/Graphics';
import { TradingToolViewBase } from './TradingToolViewBase';
export class OrderToolViewBase extends TradingToolViewBase {
    constructor() {
        super(...arguments);
        this.indentationLineLength = 14;
    }
    static getYByPrice(window, cashItemSeriesSettings, price) {
        const y = Math.round(window.PointsConverter.GetScreenY(cashItemSeriesSettings.CalculateConverter(price)));
        return y;
    }
    tryAddPlateOnPriceScale(params, priceValue, modifiedPrice, backGroundBrush) {
        if (this.Collapsed && !this.TradeWasModified) {
            return;
        }
        super.tryAddPlateOnPriceScale(params, priceValue, modifiedPrice, backGroundBrush);
    }
    getDrawingTools(isBuy, hoveredOrSelected) {
        let backgroundBrush = isBuy
            ? hoveredOrSelected
                ? TradingToolViewBase.buyBackgroundActiveBrush
                : TradingToolViewBase.buyBackgroundBrush
            : hoveredOrSelected
                ? TradingToolViewBase.sellBackgroundActiveBrush
                : TradingToolViewBase.sellBackgroundBrush;
        let backgroundPen = isBuy
            ? hoveredOrSelected
                ? TradingToolViewBase.buyBackgroundActivePen
                : TradingToolViewBase.buyBackgroundPen
            : hoveredOrSelected
                ? TradingToolViewBase.sellBackgroundActivePen
                : TradingToolViewBase.sellBackgroundPen;
        if (this.TradeWasModified) {
            backgroundBrush = TradingToolViewBase.chartOrderModifiedBrush;
            backgroundPen = TradingToolViewBase.chartOrderModifiedPen;
        }
        let TextBrush = new SolidBrush(ThemeManager.colors.chartTradeToolForefround);
        if (hoveredOrSelected) {
            TextBrush = new SolidBrush(ThemeManager.colors.chartTradeToolForefroundHovered);
        }
        return { backgroundPen, backgroundBrush, TextBrush };
    }
    getPricePlateBrush(isBuy) {
        let backGroundBrush = isBuy ? TradingToolViewBase.buyBrush : TradingToolViewBase.sellBrush;
        if (this.TradeWasModified) {
            backGroundBrush = new SolidBrush(ThemeManager.colors.chartModifyPlateOnPriceScaleBackground);
        }
        return backGroundBrush;
    }
    getButtonBrush(isBuy, isHovered, isActive = true) {
        if (this.TradeWasModified) {
            return null;
        }
        else if (isActive) {
            if (isBuy) {
                return isHovered ? TradingToolViewBase.buyTradeToolButtonBackgroundHoveredBrush : null;
            }
            else {
                return isHovered ? TradingToolViewBase.sellTradeToolButtonBackgroundHoveredBrush : null;
            }
        }
        else {
            return isHovered
                ? TradingToolViewBase.chartOrderModifiedHoveredBrush
                : TradingToolViewBase.chartOrderModifiedBrush;
        }
    }
    getPlateOffset() {
        return this.btnSize / 2 + this.indentationLineLength;
    }
    drawIcon(gr, im, rect) {
        if (rect.IsEmpty()) {
            return;
        }
        gr.DrawCenteredImage(im, rect);
    }
}
